var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApescanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 32,
    viewBox: "0 0 42 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 32,
    rx: 6,
    fill: "#0054FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6119 9.29883H15.1112L16.7231 22.701H14.6041L14.3687 19.7851H13.2458L13.0103 22.701H11L12.6119 9.29883ZM13.608 15.2574L13.3907 18.0102H14.2238L13.9884 15.2574L13.8253 12.9392H13.771L13.608 15.2574ZM21.1643 22.701H19.009V9.29883H21.8344C23.3738 9.29883 24.3156 10.2043 24.3156 11.8344V15.1306C24.3156 16.7424 23.3738 17.648 21.8344 17.648H21.1643V22.701ZM21.1824 16.0362H21.6533C22.0155 16.0362 22.1604 15.7101 22.1604 15.1306V11.8344C22.1604 11.2367 22.0155 10.9107 21.6533 10.9107H21.1824V16.0362ZM26.7982 22.701V9.29883H31V11.0737H28.9534V15.04H30.7826V16.8149H28.9534V20.9262H31V22.701H26.7982Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApescanIcon);
export default __webpack_public_path__ + "static/media/ApescanIcon.3209af680a963517b5239145ec8963c4.svg";
export { ForwardRef as ReactComponent };